import React from 'react';

interface SiteVisitIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const SiteVisitIcon: React.FC<SiteVisitIconProps> = ({
  size = 25,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 5.83333V0.5H24.5V24.5H0.5V11.1667H12.5V5.83333ZM3.16667 21.8333H5.83333V19.1667H3.16667V21.8333ZM3.16667 16.5H5.83333V13.8333H3.16667V16.5ZM9.83333 21.8333H12.5V19.1667H9.83333V21.8333ZM9.83333 16.5H12.5V13.8333H9.83333V16.5ZM9.83333 11.1667H12.5V8.5H9.83333V11.1667ZM9.83333 5.83333H12.5V3.16667H9.83333V5.83333ZM15.1667 21.8333H21.8333V19.1667H15.1667V21.8333ZM15.1667 16.5H21.8333V13.8333H15.1667V16.5ZM15.1667 11.1667H21.8333V8.5H15.1667V11.1667ZM15.1667 5.83333H21.8333V3.16667H15.1667V5.83333Z"
        fill="#27788C"
      />
      <path
        d="M12.5 11.1667H9.83333V8.5H12.5V11.1667H0.5V24.5H24.5V0.5H12.5V5.83333M12.5 5.83333V11.1667M12.5 5.83333H9.83333V3.16667H12.5V5.83333ZM3.16667 21.8333H5.83333V19.1667H3.16667V21.8333ZM3.16667 16.5H5.83333V13.8333H3.16667V16.5ZM9.83333 21.8333H12.5V19.1667H9.83333V21.8333ZM9.83333 16.5H12.5V13.8333H9.83333V16.5ZM15.1667 21.8333H21.8333V19.1667H15.1667V21.8333ZM15.1667 16.5H21.8333V13.8333H15.1667V16.5ZM15.1667 11.1667H21.8333V8.5H15.1667V11.1667ZM15.1667 5.83333H21.8333V3.16667H15.1667V5.83333Z"
        stroke="black"
      />
    </svg>
  );
};

export default SiteVisitIcon;
